import styled from 'styled-components';

const GameSelectorNavStyled = styled.nav`
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
`;

export const SVG = styled.svg`
  fill: ${props => props.theme.colors.white};
  height: 25px;
  width: 25px;

  @media screen and (min-width: ${props => props.theme.breakpoints.md}) {
    height: 30px;
    width: 30px;
  }
`;

export const GameSelectorPrev = styled.button`
  background: transparent;
  border: 0;
  cursor: pointer;
  height: 45px;
  left: 25%;
  outline: 0;
  padding: 10px;
  position: fixed;
  top: 50%;
  transform: translate(-160%, -50%);
  transition: fill ${props => props.theme.transition.duration}
    ${props => props.theme.transition.easeOut};
  z-index: 11;
  width: 45px;

  svg {
    transform: translate(-2px, 3px);
  }

  &::after {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 100%;
    bottom: 0;
    content: '';
    height: 100%;
    left: 0;
    opacity: 0;
    position: absolute;
    right: 0;
    top: 0;
    transform: scale(0);
    transform-origin: 50% 50%;
    transition: opacity ${props => props.theme.transition.duration}
        ${props => props.theme.transition.easeOut},
      transform ${props => props.theme.transition.duration}
        ${props => props.theme.transition.easeInOut};
    width: 100%;
    z-index: -1;
  }

  &:hover {
    svg {
      fill: ${props => props.theme.colors.yellow};
    }

    &::after {
      opacity: 1;
      transform: scale(1);
    }
  }

  &:active:focus {
    &::after {
      background: rgba(255, 255, 255, 0.2);
    }

    svg {
      fill: ${props => props.theme.colors.yellow};
    }
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.md}) {
    svg {
      transform: translate(-4px, 0);
    }
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.lg}) {
    left: 25%;
    transform: translate(0, -50%);
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.xxl}) {
    left: 33%;
    transform: translate(0, -50%);
  }
`;

export const GameSelectorNext = styled(GameSelectorPrev)`
  left: initial;
  right: 25%;
  transform: translate(160%, -50%);

  svg {
    transform: translate(2px, 3px);
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.md}) {
    svg {
      transform: translate(0, 1px);
    }
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.lg}) {
    right: 25%;
    transform: translate(0, -50%);
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.xxl}) {
    right: 33%;
    transform: translate(0, -50%);
  }
`;

export default GameSelectorNavStyled;



// WEBPACK FOOTER //
// ./src/components/molecules/GameSelectorNav/GameSelectorNav.styled.js